// Texty lišty kategorií a mega menu (megaMenu.js).

export default {
  labelAll: 'Všechny kategorie',
  labelRest: 'Další kategorie',
  /** chip „Slevoakce" v ocasu lišty (druhý chip „Jipos Tools" je značka, viz modul) */
  saleChip: 'Slevoakce',
  /** CTA poslední kolonky panelu, ruční znění pro hlavní kořeny katalogu */
  cta: {
    garden: 'Vše ze Zahrady →',
    build: 'Vše ze Stavby →',
    workshop: 'Vše z Dílny →',
    home: 'Vše z Domácnosti →',
    kids: 'Vše z Dětských hřišť →',
  },
  /** fallback CTA pro kořeny bez ručního znění výš */
  ctaFallback: (label) => 'Vše z kategorie ' + label + ' →',
  /** promo karta v panelu — badge + title, obrázek je v modulu (viz MEDIA) */
  promo: {
    garden: { badge: 'AKCE TÝDNE', title: 'Zahradní technika v akci' },
    build: { badge: 'SKLADEM', title: 'Stavební technika skladem' },
    workshop: { badge: 'TIP', title: 'Vybavte si dílnu' },
    home: { badge: 'NOVINKA', title: 'Ventilátory Boxer skladem' },
    kids: { badge: 'SEZÓNA', title: 'Skluzavky a houpačky na zahradu' },
    car: { badge: 'PRO ŘIDIČE', title: 'Výbava do každého auta' },
    xmas: { badge: 'SEZÓNA', title: 'Vánoční osvětlení a dekorace' },
    ppe: { badge: 'BEZPEČNOST', title: 'Ochranné pomůcky pro práci' },
    solar: { badge: 'ÚSPORY', title: 'Solární technika pro dům' },
    // „Poslední kusy" jen podle skladu, ne plošně (plán kampaní 6. 10.)
    clearance: { badge: 'VÝPRODEJ', title: 'Výprodej skladu se slevou' },
  },
};
